import type {
  DashboardKind,
  DashboardSettingsResponse,
  DashboardWidgetKey,
  UpdateDashboardCashThresholdRequest,
  UpdateDashboardWidgetsRequest,
} from "@repo/shared/types";
import { get, patch, put } from "./_client";

const BASE = "/internal/dashboard-settings";

export function getDashboardSettings() {
  return get<DashboardSettingsResponse>(BASE);
}

export function updateDashboardWidgets(dashboard: DashboardKind, widgets: DashboardWidgetKey[]) {
  return put<DashboardSettingsResponse>(`${BASE}/${dashboard}`, {
    widgets,
  } satisfies UpdateDashboardWidgetsRequest);
}

export function updateDashboardCashThreshold(cashThreshold: number) {
  return patch<DashboardSettingsResponse>(`${BASE}/cash-threshold`, {
    cashThreshold,
  } satisfies UpdateDashboardCashThresholdRequest);
}
